import { argon2id } from 'hash-wasm';
import { utf8 } from './encoding';

/** 결정 D4: Argon2id. 파라미터는 vault 헤더에 저장되어 기기·시점이 달라도 같은 키를 만든다. */
export type KdfParams = {
  alg: 'argon2id';
  memoryKiB: number;
  iterations: number;
  parallelism: number;
};

export const KDF_DEFAULT: KdfParams = { alg: 'argon2id', memoryKiB: 64 * 1024, iterations: 3, parallelism: 1 };
/** 저사양 기기 대체값 (OWASP 권고 하한 이상) */
export const KDF_LOW_END: KdfParams = { alg: 'argon2id', memoryKiB: 32 * 1024, iterations: 3, parallelism: 1 };
/** 이 값 아래로는 운영 vault를 만들지 않는다 */
export const KDF_MIN_MEMORY_KIB = 19 * 1024;

/** 테스트 전용 빠른 파라미터. 운영 경로에서는 assertProductionParams로 막는다. */
export const KDF_TEST: KdfParams = { alg: 'argon2id', memoryKiB: 256, iterations: 1, parallelism: 1 };

export function assertProductionParams(p: KdfParams): void {
  if (p.memoryKiB < KDF_MIN_MEMORY_KIB || p.iterations < 2) throw new Error('KDF 파라미터가 운영 하한보다 낮습니다');
}

export async function deriveKeyBytes(passphrase: string, salt: Uint8Array, p: KdfParams): Promise<Uint8Array> {
  const normalized = passphrase.normalize('NFC');
  if (normalized.length === 0) throw new Error('빈 passphrase');
  return argon2id({
    password: utf8.encode(normalized),
    salt,
    parallelism: p.parallelism,
    iterations: p.iterations,
    memorySize: p.memoryKiB,
    hashLength: 32,
    outputType: 'binary',
  });
}

/** 설정 시 1회 측정: 기본값이 너무 느린 기기는 저사양 파라미터 사용 */
export async function chooseKdfParams(budgetMs = 2500): Promise<KdfParams> {
  const t0 = performance.now();
  await deriveKeyBytes('benchmark', new Uint8Array(16), KDF_DEFAULT);
  return performance.now() - t0 > budgetMs ? KDF_LOW_END : KDF_DEFAULT;
}
